var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{class:['category-card', 'mx-auto', { 'on-hover scale': hover }],attrs:{"elevation":hover ? 10 : 2}},[_c('v-img',{staticClass:"white--text align-end",attrs:{"height":"175px","src":_vm.img}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }